import { route } from '@betterment/js-runtime';

import brochureUrl from '../utils/brochureUrl';

export default {
  getAccountOverviewPage(householdId: string, accountId: string) {
    return `/households/${householdId}/account/${accountId}`;
  },
  getSolo401KPlanDocuments() {
    return '/documents/plan_documents';
  },
  getClientEnvelopeStrategyStep(clientEnvelopeId: string) {
    return `/envelopes/${clientEnvelopeId}/portfolio_strategies`;
  },
  getClientEnvelopeAddBeneficiariesSummaryStep(clientEnvelopeId: string) {
    return `/envelopes/${clientEnvelopeId}/add_beneficiaries_summary`;
  },
  getClientEnvelopeAddBeneficiariesStep(clientEnvelopeId: string, legalAccountType: string, clientId: string) {
    return `/envelopes/${clientEnvelopeId}/add_beneficiaries/${legalAccountType}/${clientId}`;
  },
  getHouseholdsPage(householdId: string) {
    return `/households/${householdId}`;
  },
  getImpersonationLink(userId: string) {
    return `/clients/${userId}/impersonation`;
  },
  getMigrationStrategiesGuide() {
    return brochureUrl(
      '/hubfs/PDFs/b4a/Sales%20%2B%20RM%20Collateral/Betterment%20for%20Advisors%20-%20Tax-Aware%20Migration%20Strategies%20-%20Guide.pdf'
    );
  },
  getSellOnlySubstitutesOnePager() {
    return brochureUrl(
      '/hubfs/PDFs/b4a/Sales%20%2B%20RM%20Collateral/Betterment%20Advisor%20Solutions%20-%20Sell-only%20Substitutes%20-%20One%20Pager.pdf'
    );
  },
  getSecuritySettings() {
    return '/security_settings';
  },
  getSettingsFirmPage: route('/admin', ['firm']),
  getSettingsFeesPage: route('/admin', ['firm', 'fee']),
  getSettingsIntegrationsPage: route('/admin', ['firm_integrations']),
  getSolo401kFlow() {
    return `/solo_401k_conversion`;
  },
  getSolo401kOwnerContributionDetailsStep(intentId: string) {
    return `/contribution_details/${intentId}/owner`;
  },
  getSolo401kSpouseContributionDetailsStep(intentId: string) {
    return `/contribution_details/${intentId}/spouse`;
  },
  getSolo401kConversionIntentSent(intentId: string) {
    return `/intent_sent/${intentId}`;
  },
  getSolo401kReviewConversionDetailsStep(intentId: string) {
    return `/review_conversion_details/${intentId}`;
  },
  getSolo401kSelectOwnerFundTypeStep(intentId: string) {
    return `/select_fund_type/${intentId}/owner`;
  },
  getSolo401kSelectSpouseFundTypeStep(intentId: string) {
    return `/select_fund_type/${intentId}/spouse`;
  },
  getSolo401kHowAreFundsDistributedStep(intentId: string) {
    return `/how_are_funds_distributed/${intentId}`;
  },
  getSudoChallengeFlow() {
    return '/mfa/sudo_challenges';
  },
  getMfaSmsSetupFlow() {
    return '/mfa_sms_setup/start';
  },
  getTLHInformationPage() {
    return brochureUrl('/legal/tax-loss-harvesting');
  },
  getCostBasisAccountingArticle() {
    return brochureUrl('/resources/lowering-your-tax-bill-by-improving-our-cost-basis-accounting-methods');
  },
  getHowToSolokPage() {
    return brochureUrl(
      '/hubfs/PDFs/b4a/Sales%20%2B%20RM%20Collateral/BAS%20_%20Solo%20401k%20Advisor%20Training%20Guide_Beta%20Test.pdf'
    );
  },
  getHowRebalancingWorksPage() {
    return brochureUrl('/advisors/resources/how-portfolio-rebalancing-works-to-manage-risk');
  },
  getSolokAdoptionAgreement() {
    return '/documents/solok_adoption_agreement.pdf';
  },
  getSolo401KFormPage(advisorGoalCreationFlowId: string) {
    return `/advisor_goal_creation/${advisorGoalCreationFlowId}/solo_401k_plan/new`;
  },
  getSolo401kEnvelopesNewPage() {
    return '/solo_401k/envelopes/new';
  },
  getHouseholdPage(householdId: string) {
    return `/households/${householdId}`;
  },
  getEditSecuritiesLendingPage: route('/households', [
    { param: 'householdId' },
    'portfolio_controls',
    'edit_securities_lending',
  ]),
  getPlanIntegrationsPage(planId: number) {
    return `/plans/${planId}/integrations`;
  },
  getUnallocatedFundsGuide() {
    return brochureUrl('/work/resources/what-are-unallocated-funds');
  },
  getPortfoliosPage() {
    return '/portfolios';
  },
  getModelPortfolioPage(modelPortfolioId: string) {
    return `/portfolios/model_portfolios/${modelPortfolioId}`;
  },
  getReadOnlyPortfolioView(modelPortfolioId: string) {
    return `/portfolios/custom/${modelPortfolioId}/view`;
  },
  getCustomFundLineupPage: route('/envelopes/solo_401k_plan', [
    { param: 'solo401kPlanId' },
    'custom_fund_lineup',
    'new',
  ]),
  postSudoChallengeSmsSend: route('/api/v1', ['mfa_sudo_challenge', 'sms_send']),
  postSudoChallengeSmsResend: route('/api/v1', ['mfa_sudo_challenge', 'sms_resend']),
  postSudoChallengeConfirmation: route('/api/v1', ['mfa_sudo_challenge', 'confirmation']),
  postDismissedApplyCashFirstBillingCard: route('/api/v1', ['billing_plans', 'dismissed_apply_cash_billing_cards']),
  getFourOhOneKPlanReportsPage(planId: string) {
    return `/four_oh_one_ks/plans/${planId}/reports`;
  },
  getBillingPlanIndexPage: route('/client_billing', ['billing_plans']),
  getOnDemandBillingIndexPage: route('/client_billing', ['on_demand_billing']),
  getOnDemandBillingStartPage: route('/client_billing', ['on_demand_billing', 'start']),
  getOnDemandBillingReviewPage: route('/client_billing', ['on_demand_billing', 'flow', { param: 'id' }, 'review']),
  getOnDemandBillingResolvePage: route('/client_billing', ['on_demand_billing', 'flow', { param: 'id' }, 'resolve']),
  getCreateBillingPlanFlowRoute: route('/client_billing', ['/billing_plans', 'flow', { param: 'id' }]),
  getEditBillingPlanFlowRoute: route('/client_billing', [
    '/billing_plans',
    { param: 'billingPlanId' },
    'flow',
    { param: 'id' },
  ]),
  getBillingPlanFlowPage: route('/client_billing', [
    '/billing_plans',
    'flow',
    { param: 'id' },
    'configuration_type_selection',
  ]).absolute,
  getEditBillingPlanFlowPage: route('/client_billing', [
    '/billing_plans',
    { param: 'billingPlanId' },
    'flow',
    { param: 'id' },
    'configuration_type_selection',
  ]).absolute,
  getFourOhOneKPlanPage(planId: string) {
    return `/four_oh_one_ks/plans/${planId}`;
  },
  getFourOhOneKPlanOnboardingPage(planId: string) {
    return `/four_oh_one_ks/plans/${planId}/onboarding`;
  },
  getSummaryPage: route('/summary', []),
  getHouseholdsListPage: route('/clients', []),
  getHouseholdSummaryPage: route('/households', [{ param: 'householdId' }]),
  getHouseholdsActivityPage: route('/households', [{ param: 'householdId' }, 'activities']),
  getHouseholdsMembersPage: route('/households', [{ param: 'householdId' }, 'members']),
  getHouseholdsTaxFormsPage: route('/households', [{ param: 'householdId' }, 'tax_forms']),
  getHouseholdBillingPlanEditPage: route('/households', [{ param: 'householdId' }, 'billing_plans', 'edit']),
  getHouseholdsSettingsPage: route('/households', [{ param: 'householdId' }, 'settings']),
  getGainsAllowanceEditPage: route('/taxpayers', [{ param: 'taxpayerId' }, 'investing_annual_gains_allowance', 'edit']),
  getAddAccountPage: route('/households', [{ param: 'householdId' }, 'advisor_goal_creation_flows', 'new']),
  getSecuritySellOrderFlow: route('/', [
    'households',
    { param: 'householdId' },
    'account',
    { param: 'accountId' },
    'financial_securities',
    { param: 'financialSecurityId' },
    'sell_order',
  ]),
  getSecuritySellOrderPage: route('/', [
    'households',
    { param: 'householdId' },
    'account',
    { param: 'accountId' },
    'financial_securities',
    { param: 'financialSecurityId' },
    'sell_order',
    'new',
  ]),
  getSecuritySellOrderReviewPage: route('/', [
    'households',
    { param: 'householdId' },
    'account',
    { param: 'accountId' },
    'financial_securities',
    { param: 'financialSecurityId' },
    'sell_order',
    'review',
  ]),
  getSecuritySellOrder401kBlockedPage: route('/', [
    'households',
    { param: 'householdId' },
    'account',
    { param: 'accountId' },
    'financial_securities',
    { param: 'financialSecurityId' },
    'sell_order',
    '401k_blocked',
  ]),
  getSecuritySellOrderPendingActionPage: route('/', [
    'households',
    { param: 'householdId' },
    'account',
    { param: 'accountId' },
    'financial_securities',
    { param: 'financialSecurityId' },
    'sell_order',
    'pending_action',
  ]),
  getHouseholdAccountPage: route('/households', [{ param: 'householdId' }, 'account', { param: 'accountId' }]),
  getStartTransferPage: route('/households', [
    { param: 'householdId' },
    'advisor_rollover_intent_creation_flows',
    'new',
  ]),
  getSolo401kAddSpouseParticipantPage: route('/households', [
    { param: 'householdId' },
    'add_spouse_participant',
    { param: 'goalId' },
  ]),
  getSolo401kOtherSpouseParticipantPage: route('/households', [
    { param: 'householdId' },
    'other_spouse_participant',
    { param: 'goalId' },
  ]),
  getImpersonateClientPage: route('/clients', [{ param: 'clientId' }, 'impersonation']),
  getEditPortfolioPage: route('/advisor_edit_goal_portfolio', []),
  getRebalanceNowPage: route('/goals', [{ param: 'goalId' }, 'rebalances', 'new']),
  getGoalRebalanceSettingsEditPage(goalId: string, includeReturnTo: boolean = true) {
    let queryParams = '';
    if (includeReturnTo) {
      queryParams = `?return_to_path=${window.location.pathname}`;
    }
    return `/goals/${goalId}/rebalance_settings/edit${queryParams}`;
  },
  getEditGoalPortfolioPage(goalId: string, returnToPath: string) {
    return `/advisor_edit_goal_portfolio?goal_id=${goalId}&return_to_path=${returnToPath}`;
  },
  getHouseholdConvertFundsToRoth: route('/households', [
    'households',
    { param: 'householdId' },
    'sub_accounts',
    { param: 'subAccountId' },
    'ira_conversion',
  ]),
  getFourOhOneKsPage() {
    return '/four_oh_one_ks';
  },
  getFourOhOneKsRequestForProposalPage: route('/four_oh_one_ks', ['request_for_proposal']),
  getFourOhOneKsRequestForProposalSuccessPage: route('/four_oh_one_ks', ['request_for_proposal', 'success']),
  getClientAgreements() {
    return 'https://betterment-prod-cdn.s3.us-east-1.amazonaws.com/agreements/BettermentClientAgreements_20251125.pdf';
  },
  getSelfDirectedInvestingDisclosure() {
    return brochureUrl('/legal/self-directed-investing-disclosure');
  },
  getAdvisorInitiatedTransactionsArticle() {
    return brochureUrl('/legal/smart-transitions');
  },
  getRequestForProposalFlow() {
    return '/four_oh_one_ks/request_for_proposal';
  },
  getSupportPage: route('/support', []),
  getSecureSubmissionPortal() {
    return 'https://sendsafely.betterment.com/dropzone/bettermentforadvisors';
  },
  getAdvisorContentHub() {
    return brochureUrl('/advisors/content-hub');
  },
  getPlanSponsorResourceCenter() {
    return brochureUrl('/401k/learn/');
  },
  getFourOhOneKGlossary() {
    return brochureUrl('/resources/401k-glossary/');
  },
  getCoPilotPage: route('/co_pilot', []),
  getCoPilotAccountApprovalsPage: route('/co_pilot', ['account_approvals']),
  getCoPilotPendingInvitesPage: route('/co_pilot', ['pending_invites']),
  getCoPilotMissingBeneficiariesPage: route('/co_pilot', ['missing_beneficiaries']),
  getCoPilotPendingAcatsPage: route('/co_pilot', ['pending_acats']),
  getCoPilotFailedAcatsPage: route('/co_pilot', ['failed_acats']),
  getCoPilotAcatsApprovalsPage: route('/co_pilot', ['acats_approvals']),
  getCoPilotRmdsPage: route('/co_pilot', ['rmds']),
  getCoPilotAccountLockoutsPage: route('/co_pilot', ['account_lockouts']),
  getSecuritiesLendingDisclosure() {
    return brochureUrl('/legal/sec-lending-disclosures');
  },
  getSecuritiesLendingAgreement() {
    return 'https://betterment-prod-cdn.s3.us-east-1.amazonaws.com/agreements/Fully+Paid+Lending+-+MSLA+-+Risk+Disclosure+-+Trust+Agreement+(Final+11.04.25).pdf';
  },
  getSecuritiesLendingFAQs() {
    return brochureUrl('/help/tag/securities-lending-faqs');
  },
};
